import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M19.891 11.263c.108-.274.137-.575.082-.865a1.5 1.5 0 0 0-.392-.766l-5.714-5.985a1.4 1.4 0 0 0-.464-.335 1.37 1.37 0 0 0-1.574.317 1.5 1.5 0 0 0-.312.491 1.56 1.56 0 0 0 .01 1.157 1.5 1.5 0 0 0 .32.486l3.277 3.432H1.429c-.38 0-.743.158-1.01.438-.268.28-.419.661-.419 1.058s.15.777.418 1.058a1.4 1.4 0 0 0 1.01.438h13.696l-3.276 3.431a1.5 1.5 0 0 0-.32.486 1.56 1.56 0 0 0 .302 1.648c.134.14.294.252.47.327a1.37 1.37 0 0 0 1.104-.01 1.4 1.4 0 0 0 .464-.335l5.715-5.985c.132-.14.237-.305.308-.486"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }